import {getSanitizedMessage} from '../utils/getSanitizedMessage';

export function sanitizeMessage(next: (context: string) => void, context: string): void {
  let sanitizedMessage =getSanitizedMessage(context);
  return next(sanitizedMessage);
}
